<template>
  <el-dialog
    :close-on-click-modal="false"
    title="输入密码"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
    width="470px"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
        @sub="sub"
        labelWidth="170px"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
      >
        <!-- <section slot="status" slot-scope="prop">
          <el-checkbox label="今日不再输入密码" name="type" v-model="prop.form.status" />
        </section>-->
      </qx-custom-form>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
      >确 定</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  doWithdrawal,
} from 'api/getPay';
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '请输入车队的支付密码',
            value: 'payPasswd',
            type: 'input',
            attr: {
              type: 'password',
            },
            placeholder: '请输入密码',
          },
          {
            label: '今日不再输入密码',
            value: 'status',
            type: 'radio',
            default: 1,
            options: [
              { label: '是', value: 1 },
              { label: '否', value: 2 },
            ],
          },
        ],
        rules: { // 表单验证规则
          payPasswd: [
            { required: true, message: '请输入密码', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      this.$refs.customForm && this.$refs.customForm.reset();
      this.originData = item;
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = true;
      const res = await doWithdrawal({
        payPasswd: this.encode(form.payPasswd),
        status: form.status,
      });
      this.subLoading = false;
      if (!res.failed) {
        this.dialogFormVisible = false; // 关闭弹窗
        if (res !== 'Y') {
          this.$emit('checkMsg', res);
        } else {
          this.$message({
            type: 'success',
            message: '操作成功',
          });
          this.$emit('sub');
        }
      }
    },
  },
};
</script>

<style>
</style>
